import { AlertTriangle } from "lucide-react";
import { STATUS_COLORS, BRAND_COLORS, withAlpha } from "../lib/bookingStatus";

/**
 * 24 Jun 2026 · Zentrale Status-Badge-Komponente — Single Source of Truth für
 * die Optik der 4 System-Statusfarben (Design Guide):
 *   grau = Angefragt/Noch nicht gestartet/Storniert · blau = Geplant/In
 *   Bearbeitung · grün = Erledigt · rot = Handlungsbedarf (Fällig/Überfällig/
 *   Dringend/Problem).
 *
 * `striped` (24 Jun 2026): Kennzeichnung „Storniert/abgebrochen" — graue
 * Grundfarbe mit dezenten roten Diagonalstreifen. Rot NUR als Streifenmuster,
 * NICHT als Flächen-/Statusfarbe; storniert zählt weiterhin nicht als
 * Handlungsbedarf. Zentral hier gelöst, damit alle vier Bereiche identisch
 * aussehen.
 *
 * Der `label` bleibt bereichsspezifisch (z. B. „Überfällig", „In Betreuung"),
 * muss aber eindeutig einem der vier `colorKey`-Werte zugeordnet sein.
 */
const FG = {
  grey: BRAND_COLORS.navy,
  blue: BRAND_COLORS.ivory,
  green: BRAND_COLORS.ivory,
  red: BRAND_COLORS.ivory,
};

export function StatusBadge({ colorKey = "grey", label, testid, title, striped = false, className = "" }) {
  const key = STATUS_COLORS[colorKey] ? colorKey : "grey";
  const fg = FG[key];
  const bg = striped
    ? `repeating-linear-gradient(135deg, ${STATUS_COLORS.grey} 0 7px, ${withAlpha(STATUS_COLORS.red, 0.5)} 7px 9px)`
    : STATUS_COLORS[key];
  return (
    <span
      data-testid={testid}
      data-status-color={key}
      data-striped={striped ? "true" : "false"}
      title={title || label}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] tracking-[0.12em] uppercase font-semibold ${className}`}
      style={{ background: bg, color: fg }}
    >
      {key === "red" && !striped && <AlertTriangle className="w-3 h-3 shrink-0" strokeWidth={2} />}
      {label}
    </span>
  );
}
